import type { VideoRelease } from './types.ts';

export const MONITORING_RELEASE: VideoRelease = {
    name: 'Monitoring',
    finalLabel: 'Done',
    welcome: {
        headline: 'Monitoring is here in the admin dashboard',
        subtitle: 'A four-part video series on Dental Monitoring at ODO'
    },
    parts: [
        {
            part: 1,
            title: 'Monitoring is here',
            duration: '0:47',
            youtubeId: 'bYNaWz8AAbk',
            icon: 'signal',
            tone: 'blue',
            takeaways: [
                'Dental Monitoring now lives in the admin dashboard',
                'Notifications, Messages and Overview in the sidebar',
                'Review a notification and DM is updated too'
            ]
        },
        {
            part: 2,
            title: 'Handling notifications',
            duration: '2:29',
            youtubeId: 'ZmOhAdnxjek',
            icon: 'bell-alert',
            tone: 'amber',
            takeaways: [
                'One row per patient, most urgent first',
                'Mark reviewed and DM is updated too',
                'Assign, filter by Me and step through your list'
            ]
        },
        {
            part: 3,
            title: 'Handling messages',
            duration: '2:07',
            youtubeId: 'm_QtYPwFKCw',
            icon: 'chat-bubble-left-right',
            tone: 'rose',
            takeaways: [
                'Triage by priority and frustration',
                'Reply with quick replies, scan markup or the AI draft',
                'Nothing sends until you do'
            ]
        },
        {
            part: 4,
            title: 'The Overview',
            duration: '1:26',
            youtubeId: 'ZuJKLP6XG3g',
            icon: 'chart-bar',
            tone: 'teal',
            takeaways: [
                'The whole DM workload on one page',
                'Live counts, backlog and workload by assignee',
                'What was handled over any range'
            ]
        }
    ]
};
